import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-eye-outline',
  templateUrl: './icon-eye-outline.component.html',
  styleUrls: ['./icon-eye-outline.component.scss'],
  standalone: false,
})
export class IconEyeOutlineComponent {
  @Input() tooltip?: string;
}
